import React, { FC } from "react"
import Layout from "../components/layout"
import PrivacyPolicyView from "../views/privacy.view"
import { ROUTES } from "../content/common-content"

/**
 * Terms of use main container
 *
 */

const Privacy: FC = ({ location }) => (
  <Layout path={location.pathname} title="Privacy and Cookie Policy">
    <PrivacyPolicyView />
  </Layout>
)

export default Privacy
